import { createContext, useContext, type ComponentProps } from 'react';
import { Dialog } from '@/components/ui/dialog';

// Presentation of the current visit after an authoritative API refusal. This
// does not decide access or discard writer state. React context reaches portals
// that an HTML hidden ancestor cannot cover; installed Dialog owns focus/modal behavior.
export const ConsultationPresentationContext = createContext(false);
export const useConsultationWithheld = () => useContext(ConsultationPresentationContext);
export function ConsultationDialog(props: ComponentProps<typeof Dialog>): JSX.Element | null {
  const withheld = useConsultationWithheld();
  // Remove the presentation root as a unit so its portal/focus store closes.
  // Its parent remains mounted and retains any pending clinical writer.
  return withheld ? null : <Dialog {...props} />;
}
